<div class="menu-grid">
  <a *ngFor="let item of menuItems"
     [routerLink]="item.disabled ? null : item.link"
     class="menu-tile-link"
     [class.disabled]="item.disabled"
     (click)="item.disabled && $event.preventDefault()">
    <div class="menu-tile">
      <div class="menu-icon-wrapper">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span class="menu-item-badge" *ngIf="!item.disabled && item.count">{{ item.count }}</span>
      </div>
      <span>{{ item.title }}</span>
    </div>
  </a>
</div>
